import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import ChartModuleMore from 'highcharts/highcharts-more.js';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import Highcharts from 'highcharts';

// Initialize the exporting module
HighchartsExporting(Highcharts);
HighchartsAccessibility(Highcharts);
ChartModuleMore(Highcharts);
const GaugeChart = ({ data = {}, config = {}, subTitle = '' }) => {
    const { tickLabels = [], dataValue } = data;
    const { height, fontSize, yValue } = config;

    const generatePlotBands = () => {
        const plotBands = [];
        tickLabels.forEach((label, index) => {
            if (index === 0) return;
            const prevLabel = tickLabels[index - 1];
            plotBands.push({
                from: prevLabel.num === dataValue ? prevLabel.num + 0.5 : prevLabel.num + 0.25,
                to: label.num === dataValue ? label.num - 0.5 : label.num - 0.25,
                color: label.color,
                thickness: 7
            });
        });
        return plotBands;
    };
    const options = {
        chart: {
            type: 'gauge',
            height: height
        },
        title: {
            text: undefined
        },
        tooltip: {
            enabled: false
        },
        pane: {
            startAngle: -115,
            endAngle: 115,
            background: null,
            center: ['50%', '75%'],
            size: '105%'
        },
        yAxis: {
            min: 0,
            max: 100,
            tickLength: 0,
            minorTickInterval: null,
            labels: {
                distance: 20,
                style: {
                    fontSize: '11px',
                    top: '0px',
                    fontWeight: 'bold',
                    color: '#a7a7a7'
                },
                format: '{value}%',
                useHTML: true,
                formatter: function () {
                    const { pos } = this;
                    const angle = (dataValue / 100) * 230 - 115;
                    const minY = 15 + (dataValue / 100) * 10;
                    const separateDataValueLabel = tickLabels.length === 5;

                    if (pos == dataValue) {
                        return (
                            '<div class="location-icon" style="display: flex;"> <svg style="transform: scale(0.5) rotate(' +
                            angle +
                            'deg) translate(0, 43px);" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path style="transform: translate(' +
                            minY +
                            '%, 0px)" fillRule="evenodd" clipRule="evenodd" d="M12.6175 7.30292C12.6175 3.39979 9.84284 0.235671 6.42009 0.235671C2.99734 0.235671 0.222656 3.39979 0.222656 7.30292C0.222656 7.33183 0.222808 7.3607 0.223112 7.38953L0.223112 8.71682L0.842855 10.837L6.42054 22.8513L11.9982 10.837L12.618 8.71682V7.30337L12.6175 7.30337C12.6175 7.30322 12.6175 7.30307 12.6175 7.30292Z" fill="#EE0000" /></svg>' +
                            (!separateDataValueLabel ? '<span style=" position: absolute;">' + pos + '%</span>' : '') +
                            '</div>'
                        );
                    } else {
                        return '<span>' + pos + '%</span>';
                    }
                }
            },
            lineWidth: 0,
            plotBands: generatePlotBands(),
            //custom tick position
            tickPositioner: () => tickLabels.map((item) => item.num)
        },
        series: [
            {
                data: [dataValue],
                dataLabels: {
                    borderWidth: 0,
                    useHTML: true,
                    format: subTitle
                        ? `<div style="text-align: center;"><span style="font-size: ${fontSize}px; font-weight: bold;">{y}%</span><span style="display: block; font-size: ${
                              fontSize == 33 ? 12 : 6
                          }px; font-weight: normal;">${subTitle}</span></div>`
                        : `<span style="font-size: ${fontSize}px; font-weight: bold;">{y}%</span>`,
                    style: {
                        fontFamily: 'Verizon-NHG-eDS,Helvetica Neue, Arial, Helvetica, sans-serif',
                        fontWeight: 'bold',
                        fontSize: fontSize
                    },
                    y: yValue
                },
                dial: {
                    backgroundColor: 'transparent'
                },
                pivot: {
                    radius: 0
                }
            }
        ],
        exporting: {
            enabled: false // disable the export menu
        }
    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default GaugeChart;
